"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpiderChart = void 0;
var React = _interopRequireWildcard(require("react"));
var _highcharts = _interopRequireDefault(require("highcharts"));
var _highchartsMore = _interopRequireDefault(require("highcharts/highcharts-more"));
var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));
var _charts = require("../../../utils/charts");
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _ChartWrapper = require("../ChartWrapper");
var _SpiderChartModule = _interopRequireDefault(require("./SpiderChart.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
if (!!_highchartsMore.default && !!_highcharts.default && typeof _highchartsMore.default === 'function' && typeof _highcharts.default === 'object') {
  (0, _highchartsMore.default)(_highcharts.default);
}
const SpiderChart = _ref => {
  let {
    isLoading,
    classNames,
    cardTitle,
    customExportOptions,
    headerActions,
    series,
    hasEmptyData,
    emptyText,
    testId,
    ...userOptions
  } = _ref;
  const chartRef = React.useRef(null);
  const spiderSeries = series.map((seriesItem, index) => ({
    ...seriesItem,
    name: seriesItem.name,
    data: seriesItem.data,
    pointPlacement: 'on',
    color: (0, _charts.getDataVizColor)(index)
  }));
  const defaultSpiderChartOptions = (0, _charts.getSpiderChartOptions)();
  const chartOptions = (0, _charts.mergeChartUserOptions)(defaultSpiderChartOptions, {
    series: spiderSeries,
    ...userOptions
  });
  const {
    highChart,
    ...wrapperClassNames
  } = classNames || {};
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChartWrapper.ChartWrapper, {
    isLoading: isLoading,
    title: cardTitle,
    ref: chartRef,
    customExportOptions: customExportOptions,
    classNames: wrapperClassNames,
    headerActions: headerActions,
    hasEmptyData: hasEmptyData,
    emptyText: emptyText,
    testId: testId,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_highchartsReactOfficial.default, {
      highcharts: _highcharts.default,
      ref: chartRef,
      containerProps: {
        className: (0, _classify.default)(_SpiderChartModule.default.spiderChartContainer, highChart)
      },
      options: chartOptions
    })
  });
};
exports.SpiderChart = SpiderChart;